import { render, staticRenderFns } from "./AssetCard.vue?vue&type=template&id=ecbecc4e&"
import script from "./AssetCard.vue?vue&type=script&lang=ts&"
export * from "./AssetCard.vue?vue&type=script&lang=ts&"
import style0 from "./AssetCard.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports